import React, { useState } from 'react';
import {
  Button,
  Typography,
  Box,
  Link,
  Paper,
  Stack
} from '@mui/material';
import axios from 'axios';

const AuthSection = ({ showSnackbar }) => {
  const [authUrl, setAuthUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchAuthUrl = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/v1/google-merchant/merchant-auth-url');
      setAuthUrl(res.data.url);
      showSnackbar('✅ Auth URL fetched successfully');
    } catch {
      showSnackbar('❌ Failed to fetch auth URL', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Stack spacing={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchAuthUrl}
          disabled={loading}
        >
          {loading ? 'Fetching...' : 'Get Merchant Auth URL'}
        </Button>

        {authUrl && (
          <Paper elevation={1} sx={{ p: 2, backgroundColor: '#f8f9fa' }}>
            <Typography variant="subtitle1" gutterBottom>
              Auth URL:
            </Typography>
            <Link
              href={authUrl}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="primary"
              sx={{ wordBreak: 'break-all' }}
            >
              {authUrl}
            </Link>
          </Paper>
        )}
      </Stack>
    </Box>
  );
};

export default AuthSection;
